import { useMutation, useQueryClient } from '@tanstack/react-query';
import costCategoriesApi from '@/features/dashboard/costCategories/api/costCategoriesApi.ts';
import { costCategoriesApiQueryKeys } from '@/features/dashboard/costCategories/api/costCategoriesApi.queryKeys.ts';
import { CostCategoryRequest } from '@/features/dashboard/costCategories/types/CostCategoryRequest.ts';
import { toast } from 'sonner';

export default function useUpdateCostCategory(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: CostCategoryRequest) => costCategoriesApi.update(id, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: costCategoriesApiQueryKeys.all(),
      });
      toast.success('Kategoria kosztów została zaktualizowana');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas aktualizacji kategorii kosztów.',
      });
    },
  });
}
